import React from "react";

const ProductDescriptionCard = ({ product }) => {
    if (!product.description) return null;

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0">PRODUCT DESCRIPTION</h5>
            </div>
            <div className="card-body">
          <p>{product.description}</p>
               {product.short_description && (
                    <div className="mt-2">
                        <strong>Short Description:</strong>
                        <p className="text-muted">{product.short_description}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductDescriptionCard;